import { render, staticRenderFns } from "./UserBankAccountManagement.vue?vue&type=template&id=c022a530&"
import script from "./UserBankAccountManagement.vue?vue&type=script&lang=js&"
export * from "./UserBankAccountManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports